module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"candidateInvitation":"Приглашение кандидата"}}')
  delete Component.options._Ctor
}
